export default function regexp({ el, directive, component, cleanup }) {
    const events = ["cut", "copy", "paste"];

    events.forEach((eventType) => {
        el.addEventListener(eventType, (event) => {
            component.$wire.$set(el.name, "", false);
            event.preventDefault(); // Prevent the default action
            event.stopImmediatePropagation(); // Stop other listeners of the same event from being called
        });
    });
}
